import { getConstant } from "./constants"
import {
  theme as defaultTheme,
  engine as defaultEngine,
  palette as defaultPalette
} from "./defaultTheme"
import {
  theme as unionsNSWTheme,
  engine as unionsNSWEngine,
  palette as unionsNSWPalette,
  extraStyles as unionsNSWStyles,
  sendJoinerToActionNetwork as unionsNSWEndpoint
} from "./customs/unionsnsw/theme"
import { Theme } from "baseui/theme"
import { Client } from "styletron-engine-atomic"
import { StyleObject } from "styletron-react"
import { FormValues as PersonalDetailsFormValues } from "./pages/PersonalDetailsForm"
interface Palette {
  white: string
  black: string
  primary: string
  secondary: string
  tertiary: string
}
interface ConfigurablesObject {
  theme: Theme
  engine: Client
  palette: Palette
  extraStyles?: {
    [key: string]: StyleObject
  }
  sendJoinerData?: (joiner: PersonalDetailsFormValues) => Promise<any>
}

let configurables: ConfigurablesObject = {
  theme: defaultTheme,
  engine: defaultEngine,
  palette: defaultPalette
}

if (getConstant("formVersion")?.includes("unionsnsw")) {
  configurables.theme = unionsNSWTheme
  configurables.engine = unionsNSWEngine
  configurables.palette = unionsNSWPalette
  configurables.extraStyles = unionsNSWStyles
  configurables.sendJoinerData = unionsNSWEndpoint
}

export const {
  theme,
  engine,
  palette,
  extraStyles,
  sendJoinerData
} = configurables
